import { useContext, useState } from "react";
import DocumentsContext from "../../../context/DocumentContext/DocumentsContext";
import { clearDocumentsModal } from "../../../context/DocumentContext/Actions";
import {Dialog} from "@material-ui/core"
import styles from '../Documents.module.css'
import { useMutation } from "@apollo/client";
import { GET_ALL_FILES, DELETE_FILES, GET_FILE } from "../../../Querys/querys";
import { SuccessfulAlert } from "../../../alerts/successAlerts";

export const DeleteDocuments = (props: any) =>{
    const {state, dispatch} = useContext(DocumentsContext)
    const [activo, setactivo] = useState(false)
    const handleChange = (e: any) =>{ 
        if(e.target.value === 'ELIMINAR'){
            setactivo(true)
        }else{
            setactivo(false)
        }
    }

    const [deleteDocument] = useMutation(DELETE_FILES, {
      refetchQueries:[{query:GET_ALL_FILES}, {query:GET_FILE, variables:{id:state._id}}],
  })
  
  const handleClose = ()=>{
    clearDocumentsModal({}, dispatch);
}

    const handleDelete = async () =>{
        try{
          const idDoc = Number(state._id) 
          deleteDocument({
            variables:{
                deleteFilesId:idDoc
            },
        }).then(()=>{
            SuccessfulAlert({text:"Documento eliminado con éxito"});
        });
        handleClose();
      }catch(error){
        return "error"
      }
    }



    return(
        <Dialog aria-labelledby='costumized-dialog-title' open={state.deleteModal} fullWidth={false}  onClose={handleClose} maxWidth={"md"}>
        <div className={styles.em_container}>
          <div className={styles.contenedorCerrarModal}>
            <div 
              className={styles.cerrarModal}
              onClick={()=> handleClose()}>
            </div>
          </div>
          <div className={styles.contenedorPrincipal}>
            <div className={styles.iconoEliminar}>
            </div>
            <div className={styles.em_titulo}>
              ¿Est&aacute;s seguro de que quieres eliminar el documento?
            </div>
            <div className={styles.em_mensajePrtincipal}>
                <span>Una vez eliminado no podr&aacute;s recuperar la informaci&oacute;n</span>
                <br />
                <span className={styles.em_textoPrincipal}>Escribe ELIMINAR para confirmar</span>
            </div>
            <div>
              <input 
                className={styles.input}
                type="text"
                onChange={(e) => handleChange(e)}
              />
            </div>
          </div>
        </div>
        <div className={styles.em_contenedorBotones}>
              <button 
                className={styles.em_botonCancelar}
                onClick={()=> handleClose()}
              >
                Cancelar
              </button>
              {(activo === true ? 
                <button 
                  className={styles.em_botonConfirmarActivo}
                  onClick={()=> handleDelete()}
                  >
                  <div className={styles.em_iconoConfirmarEliminar}></div>
                    <div>
                      Confirmar
                    </div>
                </button>
              :
                <button className={styles.em_botonConfirmarInactivo}>
                  <div className={styles.em_iconoConfirmarEliminar}></div>
                    <div>
                      Confirmar
                    </div>
                </button>
              )}

            </div>
        </Dialog>
    )
}
